exports.calculateElapsedTime = calculateElapsedTime;
exports.convertUTCTimeToUTCEpoch = convertUTCTimeToUTCEpoch;
exports.el = el;
exports.els = els;
exports.elRemove = elRemove;
exports.setGlobalsForDomWrapper = setGlobalsForDomWrapper;
exports.createDateTimeStr = createDateTimeStr;

const config = require('../../config');

let notificationContainerId = '';
function calculateElapsedTime(inputDate, currentTime) {
    if (!inputDate) {
        return;
    }
    let utcEpochTime = convertUTCTimeToUTCEpoch(inputDate, currentTime);
    let totalTimeInSeconds = Math.floor((currentTime.getTime() - utcEpochTime) / 1000);
    if ((totalTimeInSeconds / 60) < 60) {
        let minutes = Math.floor(totalTimeInSeconds / 60)
        if (minutes == 0) minutes = 1;
        return minutes + (minutes == 1 ? ' minute ago' : ' minutes ago');
    } else if ((totalTimeInSeconds / 3600) < 24) {
        return Math.floor(totalTimeInSeconds / 3600) + (Math.floor(totalTimeInSeconds / 3600) == 1 ? ' hour ago' : ' hours ago');
    } else if ((totalTimeInSeconds / (3600 * 24)) <= 6) {
        return Math.floor(totalTimeInSeconds / (3600 * 24)) + (Math.floor(totalTimeInSeconds / (3600 * 24)) == 1 ? ' day ago' : ' days ago');
    } else {
        return dateFormatter(new Date(utcEpochTime));
    }

    function dateFormatter(date) {
        const dateArray = date.toDateString().split(' ');
        return (dateArray[0] + ', ' + dateArray[2] + ' ' + dateArray[1] + ', ' + dateArray[3])
    }
}

function convertUTCTimeToUTCEpoch(inputDate, currentTime) {
    let inputDateArr = inputDate.split(/[^\d]/);
    inputDate = new Date(inputDateArr[0], inputDateArr[1] - 1, inputDateArr[2], inputDateArr[3], inputDateArr[4], inputDateArr[5]);
    return inputDate.getTime() - (currentTime.getTimezoneOffset() * 60000);
}

function els(element) {
    let notificationContainer = document.getElementById(notificationContainerId);
    return notificationContainer.querySelectorAll(element);
}

function el(element) {
    let notificationContainer = document.getElementById(notificationContainerId);
    return notificationContainer.querySelector(element);
}

function elRemove(element) {
    const removingElement = el(element);
    removingElement?.parentNode?.removeChild(removingElement);
}

function setGlobalsForDomWrapper(element) {
    notificationContainerId = element;
}

const ShortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function createDateTimeStr(epochValue) {
    if (!epochValue) return '';
    const date = new Date(epochValue);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${ShortMonthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}, ${hours < 10 ? '0' + hours : hours }:${minutes < 10 ? '0' + minutes : minutes }`;
}